module.exports = __webpack_public_path__ + "static/media/delete.75821a84.svg";